import React, { Component } from 'react'
import MultiSelect from 'react-multi-select-component'

export default class MultiSelector extends Component {
  constructor(props) {
    super(props)

    const options = this.props.options.map(o => ({ label: o, value: o}))
    const selected = options.filter(o => this.props.selectedValues.includes(o.value))
    this.state = {
      selectedValues: selected,
      options: options
    }
  }

  onChange = (selected) => {
    this.setState({selectedValues: selected})
    this.props.onChange(selected.map(s => s.value))
  }

  render() {
    return (
      <MultiSelect
        options={this.state.options}
        value={this.state.selectedValues}
        onChange={this.onChange}
        displayValue={this.props.name}
        disableSearch
        ClearSelectedIcon={<React.Fragment/>}
        shouldToggleOnHover={false}
        overrideStrings={{
          'allItemsAreSelected': 'Todos',
          'clearSearch': 'Limpar pesquisa',
          'noOptions': 'Nenhuma opção',
          'search': 'Pesquisar',
          'selectAll': 'Seleccionar Todos',
          'selectSomeItems': 'Seleccionar...'
        }}
      />
    )
  }
}
